<template>
  <div class="container-fluid" :key="Math.random()">
    <loading :active.sync="isLoading" loader="dots"></loading>

    <div class="card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th colspan="4" class="title">任用單</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="1" class="text-right">應徵姓名</td>
                <td colspan="3">
                  {{ appointment.Name }}
                </td>
              </tr>

              <tr>
                <td class="width-15 text-right">
                  <span class="mark">*</span>身份別
                </td>
                <td class="width-35">
                  <ValidationProvider
                    rules="required"
                    name="身份別"
                    v-slot="{ errors }"
                  >
                    <el-select
                      class="w-100"
                      clearable
                      placeholder="請選擇"
                      v-model="appointment.IdentityType"
                    >
                      <el-option
                        label="IDL"
                        value="IDL"
                        :disabled="$route.params.Action === 'special'"
                      />
                      <el-option
                        label="IDL工讀生"
                        value="IDL工讀生"
                        :disabled="$route.params.Action === 'special'"
                      />
                      <el-option
                        label="DL"
                        value="DL"
                        :disabled="$route.params.Action === 'special'"
                      />
                      <el-option label="按摩師" value="按摩師" />
                      <el-option
                        label="DL產學合作4+2產學生(高中畢業)"
                        value="DL產學合作4+2產學生(高中畢業)"
                      />
                      <el-option
                        label="DL產學合作1年期實習生(大四學生)"
                        value="DL產學合作1年期實習生(大四學生)"
                      />
                      <el-option label="外籍" value="外籍" />
                    </el-select>
                    <p v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </td>

                <td class="width-15 text-right">
                  <span class="mark">*</span>薪制
                </td>
                <td class="width-35">
                  <ValidationProvider
                    rules="required"
                    name="薪制"
                    v-slot="{ errors }"
                  >
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        id="SalaryType1"
                        value="時薪"
                        v-model="appointment.SalaryType"
                      />
                      <label for="SalaryType1" class="form-check-label">
                        時薪
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        id="SalaryType2"
                        value="月薪"
                        v-model="appointment.SalaryType"
                      />
                      <label for="SalaryType2" class="form-check-label">
                        月薪
                      </label>
                    </div>
                    <p v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </td>
              </tr>

              <tr
                v-if="
                  !(
                    appointment.ResumeType === 'IDL' &&
                    appointment.SalaryType === '月薪'
                  )
                "
              >
                <td class="width-15 text-right">
                  <span class="mark">*</span>錄用類型
                </td>
                <td class="width-35">
                  <ValidationProvider
                    rules="required"
                    name="錄用類型"
                    v-slot="{ errors }"
                  >
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        id="EmployCategory1"
                        value="新人錄用"
                        v-model="appointment.EmployCategory"
                      />
                      <label for="EmployCategory1" class="form-check-label"
                        >新人錄用</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        id="EmployCategory2"
                        value="老人回廠/舊年資併計"
                        v-model="appointment.EmployCategory"
                      />
                      <label for="EmployCategory2" class="form-check-label">
                        老人回廠／舊年資併計
                      </label>
                    </div>
                    <p v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </td>
                <td class="width-15 text-right">
                  <span class="mark">*</span>任用部門
                </td>
                <td class="width-35">
                  <ValidationProvider
                    class="w-50"
                    name="Plant"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <el-select
                      class="w-100"
                      filterable
                      allow-create
                      clearable
                      value-key="Guid"
                      placeholder="Plant"
                      @change="
                        (deptOptions = []),
                          (appointment.AppointmentDepartment = null)
                      "
                      v-model="appointment.AppointmentPlant"
                    >
                      <el-option
                        v-for="plant in plantOptions"
                        :key="plant.Guid"
                        :label="plant.Name"
                        :value="plant"
                      >
                      </el-option>
                    </el-select>
                    <span v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="w-50"
                    name="Dept"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <el-select
                      class="w-100"
                      filterable
                      clearable
                      allow-create
                      value-key="Guid"
                      placeholder="請先選擇 Plant"
                      v-model="appointment.AppointmentDepartment"
                    >
                      <el-option
                        v-for="dept in deptOptions"
                        :key="dept.Guid"
                        :label="dept.Name"
                        :value="dept"
                      >
                      </el-option>
                    </el-select>
                    <span v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>

              <tr>
                <td class="width-15 text-right">最高學歷</td>
                <td class="width-35">
                  {{ appointment.HighestEducation }}
                </td>
                <td class="width-15 text-right">學校／科系</td>
                <td class="width-35">
                  {{ appointment.School }}／{{ appointment.Department }}
                </td>
              </tr>

              <tr>
                <td colspan="1" class="text-right">
                  <span class="mark">*</span>Offer 顯示單位
                </td>
                <td
                  :colspan="
                    !(
                      appointment.ResumeType === 'IDL' &&
                      appointment.SalaryType === '月薪'
                    )
                      ? 1
                      : 3
                  "
                >
                  <ValidationProvider
                    rules="required"
                    name="Offer 顯示單位"
                    v-slot="{ errors }"
                  >
                    <el-input
                      :disabled="!$Permission.Appointment.DLPermission.IsValid"
                      class="w-100"
                      clearable
                      v-model="appointment.OfferDisplayDepartment"
                    />
                    <span v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
                <template
                  v-if="
                    !(
                      appointment.ResumeType === 'IDL' &&
                      appointment.SalaryType === '月薪'
                    )
                  "
                >
                  <td class="width-15 text-right">
                    <span class="mark">*</span>報到日期
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required"
                      name="報到日期"
                      v-slot="{ errors }"
                    >
                      <el-date-picker
                        class="w-100"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :picker-options="{
                          disabledDate: $common.disabledDateBeforeToday,
                        }"
                        placeholder="請選擇"
                        v-model="appointment.OnBoardTime"
                      />
                      <span v-if="errors[0]" class="text-danger ml-1">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </td>
                </template>
              </tr>

              <tr>
                <td colspan="4" class="title">任用建議</td>
              </tr>

              <tr>
                <td class="width-15 text-right">
                  <span class="mark">*</span>職缺名稱
                </td>
                <td
                  :colspan="
                    !(
                      appointment.ResumeType === 'IDL' &&
                      appointment.SalaryType === '月薪'
                    )
                      ? 1
                      : 3
                  "
                >
                  <ValidationProvider
                    name="職缺名稱"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <el-select
                      class="w-100"
                      filterable
                      clearable
                      placeholder="請選擇"
                      v-model="appointment.PositionCode"
                    >
                      <el-option
                        v-for="position in positionOptions"
                        :key="position.Code"
                        :label="position.Name"
                        :value="position.Code"
                      >
                      </el-option>
                    </el-select>
                    <span v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
                <template
                  v-if="
                    !(
                      appointment.ResumeType === 'IDL' &&
                      appointment.SalaryType === '月薪'
                    )
                  "
                >
                  <td class="width-15 text-right">
                    <span class="mark">*</span>任用職稱
                  </td>
                  <td class="width-35">
                    <ValidationProvider
                      name="任用職稱"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <el-select
                        :disabled="
                          !$Permission.Appointment.DLPermission.IsValid
                        "
                        class="w-100"
                        clearable
                        placeholder="請選擇"
                        v-model="appointment.AppointmentPosition"
                      >
                        <el-option label="生產助理員" value="生產助理員" />
                        <el-option label="助理" value="助理" />
                        <el-option label="技術助理員" value="技術助理員" />
                        <el-option label="技術員" value="技術員" />
                        <el-option label="高級技術員" value="高級技術員" />
                        <el-option label="事務員" value="事務員" />
                        <el-option label="資深技術員" value="資深技術員" />
                        <el-option label="組長" value="組長" />
                        <el-option label="儲備組長" value="儲備組長" />
                        <el-option label="工讀生" value="工讀生" />
                        <el-option label="實習生" value="實習生" />
                        <el-option label="按摩師" value="按摩師" />
                      </el-select>
                      <span v-if="errors[0]" class="text-danger ml-1">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </td>
                </template>
              </tr>

              <tr
                v-if="
                  !(
                    appointment.ResumeType === 'IDL' &&
                    appointment.SalaryType === '月薪'
                  )
                "
              >
                <td class="width-15 text-right">
                  <span class="mark">*</span>職等
                </td>
                <td class="width-35">
                  <ValidationProvider
                    rules="required"
                    name="職等"
                    v-slot="{ errors }"
                  >
                    <el-select
                      :disabled="!$Permission.Appointment.DLPermission.IsValid"
                      class="w-100"
                      placeholder="請選擇"
                      v-model="appointment.Rank"
                    >
                      <el-option label="1" value="1" />
                      <el-option label="2" value="2" />
                      <el-option label="2.1" value="2.1" />
                      <el-option label="2.2" value="2.2" />
                      <el-option label="3" value="3" />
                      <template v-if="!(appointment.SalaryType === '時薪')">
                        <el-option label="4" value="4" />
                        <el-option label="5" value="5" />
                        <el-option label="6" value="6" />
                        <el-option label="6.3" value="6.3" />
                        <el-option label="7" value="7" />
                        <el-option label="7.3" value="7.3" />
                        <el-option label="8" value="8" />
                        <el-option label="8.3" value="8.3" />
                        <el-option label="9" value="9" />
                        <el-option label="9.3" value="9.3" />
                        <el-option label="10" value="10" />
                        <el-option label="10.3" value="10.3" />
                        <el-option label="10.5" value="10.5" />
                        <el-option label="10.7" value="10.7" />
                        <el-option label="11" value="11" />
                        <el-option label="11.3" value="11.3" />
                        <el-option label="11.5" value="11.5" />
                        <el-option label="12" value="12" />
                        <el-option label="13" value="13" />
                        <el-option label="13.3" value="13.3" />
                      </template>
                    </el-select>
                    <span v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
                <template
                  v-if="
                    appointment.ResumeType === 'DL' &&
                    appointment.SalaryType === '月薪'
                  "
                >
                  <td class="width-15 text-right">
                    <span class="mark">*</span>月薪
                  </td>
                  <td class="width-35">
                    <ValidationProvider
                      class="w-100"
                      name="月薪"
                      :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                      v-slot="{ errors }"
                    >
                      <input
                        :disabled="
                          !$Permission.Appointment.DLPermission.IsValid
                        "
                        class="form-control w-100"
                        type="text"
                        v-model.trim="appointment.BasicSalary"
                      />
                      <span v-if="errors" class="text-danger">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </td>
                </template>
                <template v-if="appointment.SalaryType === '時薪'">
                  <td class="width-15 text-right">
                    <span class="mark">*</span>時薪
                  </td>
                  <td class="width-35">
                    <ValidationProvider
                      class="w-100"
                      name="時薪"
                      :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                      v-slot="{ errors }"
                    >
                      <input
                        :disabled="
                          !$Permission.Appointment.DLPermission.IsValid
                        "
                        class="form-control w-100"
                        type="text"
                        v-model.trim="appointment.HourSalary"
                      />
                      <span v-if="errors" class="text-danger">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </td>
                </template>
              </tr>

              <tr
                v-if="
                  appointment.IdentityType === 'IDL工讀生' ||
                  appointment.IdentityType === '按摩師'
                "
              >
                <td class="width-15 text-right">聘僱期間(起)</td>
                <td class="width-35">
                  <el-date-picker
                    class="w-100"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="請選擇"
                    v-model="appointment.EmploymentStart"
                  />
                </td>
                <td class="width-15 text-right">聘僱期間(迄)</td>
                <td class="width-35">
                  <ValidationProvider
                    class="w-100"
                    name="聘僱期間(迄)"
                    :rules="{
                      notBeforeStartDate: appointment.EmploymentStart,
                    }"
                    v-slot="{ errors }"
                  >
                    <el-date-picker
                      class="w-100"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="請選擇"
                      v-model="appointment.EmploymentEnd"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>

              <tr
                v-if="
                  !(
                    appointment.ResumeType === 'IDL' &&
                    appointment.SalaryType === '月薪'
                  )
                "
              >
                <td class="width-15 text-right">
                  <span class="mark">*</span>工作時間
                </td>
                <td :colspan="appointment.WorkTimeType === '一般工時' ? 1 : 3">
                  <ValidationProvider
                    rules="required"
                    name="工作時間"
                    v-slot="{ errors }"
                  >
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        id="WorkTimeType1"
                        value="一般工時"
                        v-model="appointment.WorkTimeType"
                      />
                      <label for="WorkTimeType1" class="form-check-label">
                        一般工時
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        type="radio"
                        class="form-check-input"
                        id="WorkTimeType2"
                        value="特殊工時"
                        v-model="appointment.WorkTimeType"
                      />
                      <label for="WorkTimeType2" class="form-check-label">
                        特殊工時
                      </label>
                    </div>
                    <p v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </td>
                <template v-if="appointment.WorkTimeType === '一般工時'">
                  <td class="width-15 text-right">
                    <span class="mark">*</span>班別
                  </td>
                  <td class="width-35">
                    <ValidationProvider
                      rules="required"
                      name="班別"
                      v-slot="{ errors }"
                    >
                      <el-select
                        class="w-100"
                        filterable
                        clearable
                        placeholder="請選擇"
                        v-model="appointment.WorkShiftTypeGuid"
                      >
                        <el-option
                          v-for="shift in shiftOptions"
                          :key="shift.Guid"
                          :label="shift.Name"
                          :value="shift.Guid"
                        >
                        </el-option>
                      </el-select>
                      <p v-if="errors[0]" class="text-danger ml-1">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </td>
                </template>
              </tr>

              <template
                v-if="
                  appointment.WorkShiftTypeGuid ===
                  '11111111-1111-1111-1111-111111111111'
                "
              >
                <tr>
                  <td class="width-15 text-right">
                    <span class="mark">*</span>班別描述
                  </td>
                  <td class="width-35">
                    <ValidationProvider
                      rules="required"
                      name="班別描述"
                      v-slot="{ errors }"
                    >
                      <el-input
                        class="w-100"
                        type="textarea"
                        :rows="1"
                        maxlength="20"
                        show-word-limit
                        v-model="appointment.WorkShiftTypeDesc"
                      />
                      <p v-if="errors[0]" class="text-danger ml-1">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </td>
                  <td class="width-15 text-right">
                    <span class="mark">*</span>休息分鐘數
                  </td>
                  <td class="width-35">
                    <ValidationProvider
                      rules="required"
                      name="休息分鐘數"
                      v-slot="{ errors }"
                    >
                      <el-input-number
                        style="width: 100%"
                        :min="0"
                        :max="999"
                        :step="1"
                        :precision="0"
                        v-model="appointment.BreakMinute"
                      />
                      <p v-if="errors[0]" class="text-danger ml-1">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </td>
                </tr>

                <tr>
                  <td class="width-15 text-right">
                    <span class="mark">*</span>每日工時
                  </td>
                  <td class="width-35">
                    <ValidationProvider
                      rules="required"
                      name="每日工時"
                      v-slot="{ errors }"
                    >
                      <el-input-number
                        style="width: 100%"
                        :min="0"
                        :max="24"
                        :step="1"
                        :precision="0"
                        v-model="appointment.DailyWorkHour"
                      />
                      <p v-if="errors[0]" class="text-danger ml-1">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </td>
                  <td class="width-15 text-right">
                    <span class="mark">*</span>每週工時
                  </td>
                  <td class="width-35">
                    <ValidationProvider
                      rules="required"
                      name="每週工時"
                      v-slot="{ errors }"
                    >
                      <el-input-number
                        style="width: 100%"
                        :min="0"
                        :max="168"
                        :step="1"
                        :precision="0"
                        v-model="appointment.WeeklyWorkHour"
                      />
                      <p v-if="errors[0]" class="text-danger ml-1">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </td>
                </tr>
              </template>

              <tr v-if="appointment.WorkTimeType === '特殊工時'">
                <td class="width-15 text-right">
                  <span class="mark">*</span>出勤類型
                </td>
                <td colspan="3">
                  <ValidationProvider
                    rules="required"
                    name="出勤類型"
                    v-slot="{ errors }"
                  >
                    <input
                      id="SpecialWorkTimeType1"
                      type="radio"
                      value="週一至週五"
                      v-model="appointment.SpecialWorkTimeType"
                    />
                    <label class="mr-4" for="SpecialWorkTimeType1"
                      >週一至週五</label
                    >
                    <input
                      id="SpecialWorkTimeType2"
                      type="radio"
                      value="約定工時"
                      v-model="appointment.SpecialWorkTimeType"
                    />
                    <label for="SpecialWorkTimeType2">約定工時</label>
                    <p v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </td>
              </tr>

              <tr
                v-if="
                  appointment.WorkTimeType === '特殊工時' &&
                  appointment.SpecialWorkTimeType === '約定工時'
                "
              >
                <td class="width-15 text-right">
                  <span class="mark">*</span>約定週工時
                </td>
                <td colspan="1">
                  <ValidationProvider
                    rules="required"
                    name="約定週工時"
                    v-slot="{ errors }"
                  >
                    <el-input-number
                      style="width: 100%"
                      :min="0"
                      :max="168"
                      :step="1"
                      :precision="0"
                      v-model="appointment.SpecialWeeklyHour"
                    />
                    <p v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </td>
                <td class="width-15 text-right">
                  <span class="mark">*</span>約定月工時
                </td>
                <td colspan="1">
                  <ValidationProvider
                    rules="required"
                    name="約定月工時"
                    v-slot="{ errors }"
                  >
                    <el-input-number
                      style="width: 100%"
                      :min="0"
                      :max="744"
                      :step="1"
                      :precision="0"
                      v-model="appointment.SpecialMonthlyHour"
                    />
                    <p v-if="errors[0]" class="text-danger ml-1">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </td>
              </tr>

              <tr>
                <td class="text-right">其他說明</td>
                <td colspan="3">
                  <el-input
                    class="w-100"
                    type="textarea"
                    :rows="5"
                    maxlength="400"
                    show-word-limit
                    v-model="appointment.Description"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="button-wrap center">
            <button
              type="button"
              class="btn btn-secondary mr-1"
              @click="$router.back()"
            >
              返回
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="handleSubmit(saveAppointmentForm)"
            >
              儲存
            </button>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TheAppointmentForm",
  data() {
    return {
      action: null,
      // 任用部門
      appointDepartment: null,

      appointment: {},

      plantOptions: [],
      deptOptions: [],
      positionOptions: [],
      shiftOptions: [],
    };
  },

  methods: {
    // 取得 任用單
    getAppointmentForm() {
      if (this.$route.params.Action !== "edit") {
        this.$api.appointment
          .getAppointment(this.$route.params.MatchId)
          .then((response) => {
            if (response.status === 200) {
              this.appointment = response.data;
            }
          });
      }
    },

    // 儲存 任用單
    saveAppointmentForm() {
      let AppointmentPlant, AppointmentDepartment, api;
      if (typeof this.appointment.AppointmentPlant === "string") {
        AppointmentPlant = {
          Guid: null,
          Name: this.appointment.AppointmentPlant,
        };
      } else {
        AppointmentPlant = this.appointment.AppointmentPlant;
      }
      if (typeof this.appointment.AppointmentDepartment === "string") {
        AppointmentDepartment = {
          Guid: null,
          Name: this.appointment.AppointmentDepartment,
        };
      } else {
        AppointmentDepartment = this.appointment.AppointmentDepartment;
      }

      this.updateLoading(true);
      if (this.$route.params.Action === "special") {
        api = "postSkipInterview";
      } else {
        api = "postAppointment";
      }
      this.$api.appointment[api]({
        ...this.appointment,
        AppointmentPlant: AppointmentPlant,
        AppointmentDepartment: AppointmentDepartment,
        BasicSalary: this.appointment.BasicSalary
          ? Number(this.appointment.BasicSalary.replace(/,/g, ""))
          : null,
        HourSalary: this.appointment.HourSalary
          ? Number(this.appointment.HourSalary.replace(/,/g, ""))
          : null,
      }).then((response) => {
        if (response.status === 200) {
          this.updateLoading(false);
          this.$notify({
            title: "成功",
            message: "儲存成功",
            type: "success",
            duration: 2500,
          });
          this.$router.go(-1);
        }
      });
    },

    // loading
    ...mapActions(["updateLoading"]),

    async getData() {
      await this.getAppointmentForm();
      try {
        // 取得 plant
        const plant = await this.$api.employeePlant.getPlant();
        this.plantOptions = plant.data.map((item) => {
          return {
            Guid: item.Guid,
            Name: item.Name,
          };
        });
        // 取得 職務
        const position = await this.$api.position.getPositionPaging({
          isPaging: false,
        });

        this.positionOptions = position.data.Datas.map((item) => {
          return {
            Code: item.PositionCode,
            Name: item.PositionName,
          };
        });
        // 取得 班別
        const shift = await this.$api.workShift.getWorkShift();
        this.shiftOptions = shift.data.map((item) => {
          return {
            Guid: item.Guid,
            Name: item.Name,
          };
        });
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },
  computed: {
    openK2: function () {
      return this.$store.state.openK2;
    },
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    // EmployeePlant
    "appointment.AppointmentPlant": async function (newVal) {
      if (newVal && typeof newVal !== "string") {
        // 取得 EmployeeDepartment
        const dept = await this.$api.employeeDepartment.getEmployeeDepartment({
          EmployeePlantGuid: newVal.Guid,
        });
        this.deptOptions = dept.data.map((item) => {
          return {
            Guid: item.Guid,
            Name: item.Name,
          };
        });
      }
    },

    // 薪制
    "appointment.SalaryType": function (newVal) {
      if (newVal === "時薪") {
        if (this.appointment.Rank > 3) {
          this.appointment.Rank = null;
        }
      }
    },

    // 月薪
    "appointment.BasicSalary": function (newVal) {
      if (newVal) {
        this.appointment.BasicSalary = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },

    // 時薪
    "appointment.HourSalary": function (newVal) {
      if (newVal) {
        this.appointment.HourSalary = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },

    // 工作時間
    "appointment.WorkTimeType": function (newVal) {
      if (newVal) {
        this.appointment.WorkShiftTypeGuid = null;
      }
    },
  },

  created() {
    this.getData();
    // 取得K2系統開關
    this.$store.dispatch("openK2");
  },
};
</script>

<style lang="scss" scoped>
.width-15 {
  width: 15%;
}
.width-35 {
  width: 35%;
}

.card {
  margin-top: 20px;
}
.title {
  background-color: #636f83;
  color: #ffffff;
  text-align: center;
  font-weight: bolder;
}
.mark {
  background-color: inherit;
  color: red;
}
.btn-search {
  margin-left: 10px;
}
.go-back {
  margin-top: 20px;
  border: none;
  font-size: 0.8em;
  background-color: #303c50;
  border-radius: 25px;
  padding: 6px 10px;
  color: #fff;
  i {
    margin-right: 5px;
  }
}

#choiceSupervisorModal {
  .modal-body {
    max-height: unset;
    overflow: unset;
  }
  .job-position {
    width: 270px;
    left: -160px;
    bottom: -70px;
    position: relative;
    @media screen and (max-width: 767px) {
      opacity: 0;
    }
  }
}
</style>
